class BackToTopButton extends HTMLElement {
  #scrollRafId = null;

  connectedCallback() {
    this.threshold = Number(this.dataset.scrollThreshold) || 500;
    this.button = this.querySelector('.back-to-top__button');

    this.button.addEventListener('click', this.handleClick);
    document.addEventListener('scroll', this.handleScroll, { passive: true });

    this.updateVisibility();
  }

  disconnectedCallback() {
    this.button.removeEventListener('click', this.handleClick);
    document.removeEventListener('scroll', this.handleScroll);

    if (this.#scrollRafId !== null) {
      cancelAnimationFrame(this.#scrollRafId);
      this.#scrollRafId = null;
    }
  }

  handleClick = () => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    window.scrollTo({
      top: 0,
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
    });
  };

  handleScroll = () => {
    if (this.#scrollRafId !== null) return;

    this.#scrollRafId = requestAnimationFrame(() => {
      this.#scrollRafId = null;
      this.updateVisibility();
    });
  };

  updateVisibility() {
    const scrollTop = document.scrollingElement?.scrollTop ?? 0;
    const visible = scrollTop > this.threshold;

    this.toggleAttribute('visible', visible);
    this.button.setAttribute('tabindex', visible ? '0' : '-1');
  }
}

if (!customElements.get('back-to-top-button')) {
  customElements.define('back-to-top-button', BackToTopButton);
}
